import QuestionObj from '../Models/QuestionObj';

const SalesMidOffice_QSet = [    
    new QuestionObj({
        questionSet:{
            English: 'Are your applications connected across all customer touchpoints to give you a full view of your customers’ journey?',
            German: 'German Q1',
            French: "French Q1",
            Russian: "Russian Q1",
            Turkish: "Turkish Q1",
            Italian: "Italian Q1",
            Spanish: "Spanish Q1",
            PortugueseBR: "PortugueseBR Q1",
            SpanishLAD: "SpanishLAD Q1",
        },
        answerSet:{
            English: [
                "No, our applications are siloed and disconnected",
                "Some applications are integrated, but the data isn’t connected or complete",
                "Yes, our apps are integrated, and data is connected",
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 66, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Do you have visibility into deal metrics to drive reliable data and offer management?',
            German: 'German Q2',
            French: "French Q2",
            Russian: "Russian Q2",
            Turkish: "Turkish Q2",
            Italian: "Italian Q2",
            Spanish: "Spanish Q2",
            PortugueseBR: "PortugueseBR Q2",
            SpanishLAD: "SpanishLAD Q2",
        },
        answerSet:{
            English: [
                'No',
                'We have some visibility into deal metrics',
                'Yes, we have full visibility into deal metrics and offer data',
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 66, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Can you automatically route contracts for review, signature, and approval?',
            German: 'German Q3',
            French: "French Q3",
            Russian: "Russian Q3",
            Turkish: "Turkish Q3",
            Italian: "Italian Q3",
            Spanish: "Spanish Q3",
            PortugueseBR: "PortugueseBR Q3",
            SpanishLAD: "SpanishLAD Q3",
        },
        answerSet:{
            English: [
                'No',
                'We have some of the process automated, but not end-to-end',
                'Yes',               
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 66, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Can you sell complex products while supporting the broad spectrum of order-to-revenue processes?',
            German: 'German Q4',
            French: "French Q4",
            Russian: "Russian Q4",
            Turkish: "Turkish Q4",
            Italian: "Italian Q4",
            Spanish: "Spanish Q4",
            PortugueseBR: "PortugueseBR Q4",
            SpanishLAD: "SpanishLAD Q4",
        },
        answerSet:{
            English: [
                "No, we do not support complex selling nor order-to-revenue processes",
                "Yes, we support both complex selling and all order-to-revenue processes",
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Can your organization easily and efficiently generate proposals?',
            German: 'German Q5',
            French: "French Q5",
            Russian: "Russian Q5",
            Turkish: "Turkish Q5",
            Italian: "Italian Q5",
            Spanish: "Spanish Q5",
            PortugueseBR: "PortugueseBR Q5",
            SpanishLAD: "SpanishLAD Q5",
        },
        answerSet:{
            English: [
                "No, we do not currently have an automated way to guide the proposal process",
                "Yes, our current solution allows us to create, customize, and deliver quotes to customers",
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Can you easily deploy standardized pricing and discounts across all sales channels?',
            German: 'German Q6',
            French: "French Q6",
            Russian: "Russian Q6",
            Turkish: "Turkish Q6",
            Italian: "Italian Q6",
            Spanish: "Spanish Q6",
            PortugueseBR: "PortugueseBR Q6",
            SpanishLAD: "SpanishLAD Q6",
        },
        answerSet:{
            English: [
                "No", 
                "Not all pricing and discounting models are consistent",
                "Yes"
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 66, 100],
    }),
];

export default SalesMidOffice_QSet;